import { useSmartFilters } from "./useSmartFilters";
import { FilterState } from "../FilterSidebar/FilterState";
import { SmartFilter } from "./types";

export const useSmartFiltersActive = (filterState?: FilterState) => {
  const smartFilters = useSmartFilters();
  if (!filterState) return false;
  for (const smartFilter of smartFilters?.smartFilters || []) {
    if (smartFilterActive(smartFilter, filterState)) return true;
  }
  return false;
};

const smartFilterActive = (
  smartFilter: SmartFilter,
  filterState: FilterState,
) => {
  return (
    (filterState &&
      smartFilter.options.find((opt) => opt.filterState.isEqual(filterState))
        ?.value) ||
    null
  );
};
